import { IconButton } from '@creditornot/cb-button';
import { MoreHorizontal } from '@creditornot/cb-icons';
import { MenuActionItem } from '@creditornot/cb-menu';
import { LegacyPopover } from '@creditornot/cb-popover';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
  optionBindingId: string;
  onDeleteOptionBinding: (id: string) => void;
};

const Root = styled.div``;

const ToggleButton = styled(IconButton).attrs({ variant: 'brand', size: 'tiny' })``;

const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 200px;
`;

const OptionBindingActionsFormSection = ({ optionBindingId, onDeleteOptionBinding }: Props) => {
  const [show, setShow] = useState(false);

  const handleClose = useCallback(() => {
    setShow(false);
  }, []);

  return (
    <Root onClick={e => e.stopPropagation()}>
      <LegacyPopover
        show={show}
        onClickOutside={handleClose}
        onClickInside={handleClose}
        placement="bottom-start"
        renderArrow={false}
        content={
          <PopoverContent>
            <MenuActionItem variant="red">
              <div onClick={() => onDeleteOptionBinding(optionBindingId)}>
                <FormattedMessage id="menu-option-instance.deleteOptionInstance" />
              </div>
            </MenuActionItem>
          </PopoverContent>
        }
      >
        <ToggleButton onClick={() => setShow(v => !v)}>
          <MoreHorizontal />
        </ToggleButton>
      </LegacyPopover>
    </Root>
  );
};

export default OptionBindingActionsFormSection;
